var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "gfu-grid__cell gfu-1of3",
          attrs: { "data-qa": `filtersbox-field:${_vm.displayName}` },
        },
        [
          _c(
            "auto-complete-field",
            _vm._b(
              {
                ref: "autoCompleteField",
                attrs: {
                  value: _vm.value,
                  "label-class": "gfu-field__label--gray",
                  small: true,
                  placeholder: `start typing to get suggestions...`,
                },
                on: { input: _vm.onInput, "term-changed": _vm.onTermChanged },
              },
              "auto-complete-field",
              { ..._vm.$attrs, ..._vm.$props },
              false
            )
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }